import { onEachPageTeardown } from '@app/adapters/page-teardown'

const eventListenersToRemove = []

const removeRegisteredListeners = () => {
  eventListenersToRemove.forEach((listener) => listener())
  eventListenersToRemove.length = 0
}

const makeBuildDatepickerCallback =
  (buildDatepicker, formSubmit) => (datepickerCandidates) => {
    datepickerCandidates.forEach((element) => {
      const { execute, on: datepickerOn } = buildDatepicker(element, {
        orientation: 'bottom left',
      })

      const removeListener = datepickerOn('change', () => {
        execute('hide')
        const form = element.closest('form')
        formSubmit(form)
      })

      eventListenersToRemove.push(removeListener)
    })
  }

export default ({ buildDatepicker, formSubmit, onDomLoad } = {}) => {
  const buildDatepickerElements = makeBuildDatepickerCallback(
    buildDatepicker,
    formSubmit
  )

  const handleDatepickers = () => {
    removeRegisteredListeners()

    const datepickerCandidates = document.querySelectorAll(
      '[data-behaviour~="admin-ledger-date-picker"] input[type=text]'
    )

    buildDatepickerElements(datepickerCandidates)
  }

  onDomLoad(() => {
    handleDatepickers()
  })

  window.eventHub.$on('progress-checker:global-replace-html', handleDatepickers)

  const removeTeardownListener = onEachPageTeardown(removeRegisteredListeners)

  return () => {
    removeTeardownListener()
    removeRegisteredListeners()

    window.eventHub.$off(
      'progress-checker:global-replace-html',
      handleDatepickers
    )
  }
}
